import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import CustomLoading from "../../../Components/GeneralComponents/CustomLoading/customloading";
import { CORPORATE_ROUTES, CORPORATE_USERTYPE } from "../constants/corporateConstants";
import { clearCorporateSession, getCompanyMe } from "../services/corporateAuthService";
import { corporateFeRouteTrace } from "../utils/corporateFeTrace";

export default function SecureCorporateGate({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ status: "loading", me: null });

  useEffect(() => {
    corporateFeRouteTrace("SecureCorporateGate mounted", { pathname: location.pathname });
  }, [location.pathname]);

  useEffect(() => {
    let cancelled = false;
    corporateFeRouteTrace("gate check start", { pathname: location.pathname });

    (async () => {
      try {
        const me = await getCompanyMe();
        if (cancelled) return;
        const usertype = String(me?.usertype || "").toLowerCase();
        if (me?.ok && usertype === CORPORATE_USERTYPE && me?.context?.user_type) {
          corporateFeRouteTrace("gate allowed", {
            pathname: location.pathname,
            user_type: me.context.user_type,
          });
          setState({ status: "ok", me });
          return;
        }
        corporateFeRouteTrace("gate denied", { pathname: location.pathname, error: me?.error });
        clearCorporateSession();
        setState({ status: "denied", me });
      } catch (err) {
        if (cancelled) return;
        corporateFeRouteTrace("gate error", {
          pathname: location.pathname,
          message: err?.message,
        });
        clearCorporateSession();
        setState({ status: "denied", me: null });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (state.status === "loading") {
    return <CustomLoading />;
  }

  if (state.status === "denied") {
    return (
      <Navigate
        to={CORPORATE_ROUTES.LOGIN}
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (children) {
    return typeof children === "function" ? children(state.me) : children;
  }

  return <Outlet context={state.me} />;
}
